export default "/_next/static/images/unlimited-card-42b13f647a2ab130b5127b189f51780f.png";